"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDispatchDashboardCommand = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = require("react");
var DashboardStoreProvider_1 = require("./DashboardStoreProvider");
/**
 * Hook that takes command creator and returns function that will result into dispatching this command.
 *
 * @remarks
 * The created function takes original command creators parameters as per example below.
 *
 * @example
 * ```
 * // create a dashboard command to reset AttributeFilter selection
 * const resetAttributeFilter = useDispatchDashboardCommand(resetAttributeFilterSelection);
 *
 * // somewhere else in the code call the command to reset the filters
 * **
 * resetAttributeFilter(<dashboard-local-id>);
 * **
 * ```
 *
 * @param commandCreator - command factory
 * @returns callback that dispatches the command
 * @public
 */
exports.useDispatchDashboardCommand = function (commandCreator) {
    var dispatch = DashboardStoreProvider_1.useDashboardDispatch();
    return react_1.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var command = commandCreator.apply(void 0, tslib_1.__spread(args));
        dispatch(command);
    }, [commandCreator]);
};
//# sourceMappingURL=useDispatchDashboardCommand.js.map